import { cn } from '@/lib/cn';

interface RatingStarsProps {
  value: number;
  outOf?: number;
  size?: 'sm' | 'md' | 'lg';
  onChange?: (value: number) => void;
  className?: string;
}

export function RatingStars({ value, outOf = 5, size = 'md', onChange, className }: RatingStarsProps) {
  const sizes = { sm: 'text-sm', md: 'text-base', lg: 'text-2xl' }[size];
  return (
    <div className={cn('flex items-center gap-0.5', sizes, className)}>
      {Array.from({ length: outOf }).map((_, i) => {
        const filled = i < Math.round(value);
        const star = (
          <span aria-hidden className={filled ? 'text-makhe-ochre' : 'text-makhe-line'}>
            ★
          </span>
        );
        if (onChange) {
          return (
            <button
              key={i}
              type="button"
              onClick={() => onChange(i + 1)}
              aria-label={`Rate ${i + 1}`}
              className="cursor-pointer p-0.5"
            >
              {star}
            </button>
          );
        }
        return <span key={i}>{star}</span>;
      })}
    </div>
  );
}
